'use client';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
/**
 * Обрабатывает ошибку, применяя к ней трансформирующую функцию.
 */ const handleErrorTransform = /*#__PURE__*/ _async_to_generator(function*(error, transformError = /*#__PURE__*/ _async_to_generator(function*(error) {
    return error;
})) {
    let handledError = null;
    let unhandledError;
    try {
        handledError = yield transformError(error);
    } catch (error) {
        unhandledError = error;
    }
    return handledError != null ? handledError : unhandledError;
});

export { handleErrorTransform };
//# sourceMappingURL=handleErrorTransform.js.map
